import script from "./FranchiseDayCarts.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayCarts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FranchiseDayBottleList from "@/components/franchise/FranchiseDayBottleList.vue";
script.components = Object.assign({}, { FranchiseDayBottleList }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FranchiseDayBottleList }, script.__o.components);}